import { render, staticRenderFns } from "./WidgetFloatingBarGraph.vue?vue&type=template&id=c03abbf6&scoped=true&"
import script from "./WidgetFloatingBarGraph.vue?vue&type=script&lang=js&"
export * from "./WidgetFloatingBarGraph.vue?vue&type=script&lang=js&"
import style0 from "./WidgetFloatingBarGraph.vue?vue&type=style&index=0&id=c03abbf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03abbf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c03abbf6')) {
      api.createRecord('c03abbf6', component.options)
    } else {
      api.reload('c03abbf6', component.options)
    }
    module.hot.accept("./WidgetFloatingBarGraph.vue?vue&type=template&id=c03abbf6&scoped=true&", function () {
      api.rerender('c03abbf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/widgets/WidgetFloatingBarGraph.vue"
export default component.exports